import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import parse from "html-react-parser";
import React, { useEffect, useRef } from "react";
import { useInViewport } from 'react-in-viewport';
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import * as s from "./contactForm.module.css";
import { webhookEvents } from "../../../utils/webhookService";

const ContactForm = ({ block }) => {

  const blockRef = useRef();
  const { enterCount } = useInViewport(blockRef, {}, { disconnectOnLeave: false }, {});

  const form = useRef();
  const [name, setName] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [jobtitle, setJobTitle] = React.useState("");
  const [businessName, setBusinessName] = React.useState("");
  const [businesstype, setBusinesstype] = React.useState("");
  const [POSSystemSelect, setPOSSystemSelect] = React.useState("");
  const [possystem, setPOSSystem] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [messageSent, setMessageSent] = React.useState(false);


  useEffect(() => {
    setName(`${firstName} ${lastName}`);
  }, [firstName, lastName]);

  useEffect(() => {
    if (!!POSSystemSelect) {
      if ('Other' == POSSystemSelect) {
        setPOSSystem('');
      } else {
        setPOSSystem(POSSystemSelect);
      }
    }
  }, [POSSystemSelect]);

  const [
    iConcentToReceiveTextNotifications,
    setIConcentToReceiveTextNotifications,
  ] = React.useState(true);
  const [
    iConcentToReceiveTextNotificationsText,
    setConcentToReceiveTextNotificationsText,
  ] = React.useState("Yes");

  const [
    textRemindersText,
    setTextRemindersText,
  ] = React.useState("Yes");

  const handleSubmit = event => {
    event.preventDefault();

    const formData = {
      name: name || "",
      firstName: firstName,
      lastName: lastName,
      email: email || "",
      phone: phone || "",
      jobtitle: jobtitle || "",
      businessName: businessName || "",
      businesstype: businesstype || "",
      possystem: possystem || "",
      iConcentToReceiveTextNotifications: iConcentToReceiveTextNotifications ? "Yes" : "No",
      textReminders: textRemindersText,
    };

    webhookEvents.lead(formData, {
      onSuccess: () => {
        setName("");
        setEmail("");
        setJobTitle("");
        setBusinessName("");
        setBusinesstype("");
        setPhone("");
        setMessageSent(true);
      },
      onError: (error) => {
        console.error("Contact form submission failed:", error);
      }
    });
  };

  const titleDefault = (
    <>Take The First Step Towards A More<br /> Powerful&nbsp;
      <div className={s.titleBg}>
        <span style={{ backgroundImage: 'linear-gradient(270deg, #FE6B01 11.51%, #FF8A00 71.84%)', zIndex: 1 }} className="position-relative">
          Ordering Solution
        </span>
      </div>
    </>
  );

  const thankYouImage = {
    data: block?.thankYou?.image?.localFile?.childImageSharp?.gatsbyImageData,
    alt: block?.thankYou?.image?.altText || ``,
  }

  return (
    <section className={s.contactForm} id="contact-form" ref={blockRef}>
      {enterCount > 0 &&
        <div className="container">
          <div className={`${s.formContent} row align-items-center justify-content-center`}>
            <div className="col-12 d-flex flex-column justify-content-center">
              {!!block?.showTitle && <>
                {!!block?.useH1
                  ? <h1 className={`gradient-title ${s.title}`}>
                    {!!block?.title ? parse(block?.title) : titleDefault}
                  </h1>
                  : <h2 className={`gradient-title ${s.title}`}>
                    {!!block?.title ? parse(block?.title) : titleDefault}
                  </h2>
                }
              </>
              }
              {!!block?.description && <div className={s.description}>{parse(block?.description)}</div>}
            </div>
            <div className="col-12 col-md-8 col-xl-5 d-flex flex-column justify-content-center px-0">
              <div className={`${s.formShortcode} text-lg-center`}>
                {messageSent === false && (
                  <form
                    onSubmit={handleSubmit}
                    ref={form}
                    className="wpcf7-form init"
                    data-status="init"
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <label>
                          <span className="pl-2">First Name</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-name mt-2 d-block">
                            <input
                              type="text"
                              name="firstName"
                              value={firstName}
                              onChange={e => setFirstName(e.target.value)}
                              size="40"
                              required
                              pattern="^(?!\s*$).+"
                            />
                          </span>
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <label>
                          <span className="pl-2">Last Name</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-name mt-2 d-block">
                            <input
                              type="text"
                              name="lastName"
                              value={lastName}
                              onChange={e => setLastName(e.target.value)}
                              size="40"
                              required
                              pattern="^(?!\s*$).+"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mt-3">
                        <label>
                          <span className="pl-2">Email</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-email mt-2 d-block">
                            <input
                              type="email"
                              name="email"
                              size="40"
                              value={email}
                              onChange={e => setEmail(e.target.value)}
                              required
                            />
                          </span>
                        </label>
                      </div>
                      <div className="col-lg-6 mt-3">
                        <label>
                          <span className="pl-2">Phone Number</span>
                          <span className="wpcf7-form-control-wrap customer-phone mt-2 d-block rounded">
                            <PhoneInput
                              defaultCountry="US"
                              value={phone}
                              onChange={setPhone}
                              countrySelectProps={{
                                display: 'none'
                              }}
                              className="mb-0"
                              required
                              name="phone"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label>
                          <span className="pl-2">What's Your Job Title?</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-job-title mt-2 d-block">
                            <input
                              type="text"
                              name="jobtitle"
                              size="40"
                              value={jobtitle}
                              onChange={e => setJobTitle(e.target.value)}
                              required
                              pattern="^(?!\s*$).+"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label>
                          <span className="pl-2">What's Your Restaurant Name?</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-business mt-2 d-block">
                            <input
                              type="text"
                              name="businessName"
                              size="40"
                              value={businessName}
                              onChange={e => setBusinessName(e.target.value)}
                              required
                              pattern="^(?!\s*$).+"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 mt-3">
                        <label>
                          <span className="pl-2">Business Type</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-business-type mt-2 d-block">
                            <select
                              name="businesstype"
                              value={businesstype}
                              onChange={e => setBusinesstype(e.target.value)}
                              required
                            >
                              <option value="">Select</option>
                              <option value="Single Location">Single Location</option>
                              <option value="Multi-Location">Multi-Location</option>
                              <option value="Franchise">Franchise</option>
                              <option value="Ghost Kitchen">Ghost Kitchen</option>
                              <option value="Convenience Store">Convenience Store</option>
                              <option value="Bar &amp; Brewery">Bar &amp; Brewery</option>
                              <option value="Hotel &amp; Resort">Hotel &amp; Resort</option>
                              <option value="Reseller">Reseller</option>
                              <option value="Virtual Brand Licensor">Virtual Brand Licensor</option>
                              <option value="Other">Other</option>
                            </select>
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 mt-3">
                        <label>
                          <span className="pl-2">What POS system do you currently use?</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-business-type mt-2 d-block">
                            <select
                              name="POSSystemSelect"
                              value={POSSystemSelect}
                              onChange={e => setPOSSystemSelect(e.target.value)}
                              required
                            >
                              <option value="" disabled>Select</option>
                              <option value="Square">Square</option>
                              <option value="Clover">Clover</option>
                              <option value="Toast">Toast</option>
                              <option value="SpotON">SpotON</option>
                              <option value="Aloha">Aloha</option>
                              <option value="Other">Other</option>
                            </select>
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className={`${'Other' == POSSystemSelect ? '' : 'd-none'} row`}>
                      <div className="col-12 mt-3">
                        <label>
                          <span className="pl-2">Other POS System Name</span>
                          <br />
                          <span className="wpcf7-form-control-wrap customer-business mt-2 d-block">
                            <input
                              type="text"
                              name="possystem"
                              size="40"
                              value={possystem}
                              onChange={e => setPOSSystem(e.target.value)}
                              required
                              pattern="^(?!\s*$).+"
                            />
                          </span>
                        </label>
                      </div>
                    </div>

                    <div className="mb-4 mt-4 d-flex justify-content-center">
                      <label
                        className="d-flex align-items-center cursor-pointer"
                        style={{ gap: "8px" }}
                      >
                        <input
                          type="hidden"
                          value={iConcentToReceiveTextNotificationsText}
                          name="iConcentToReceiveTextNotifications"
                        />
                        <input
                          type="hidden"
                          value={textRemindersText}
                          name="textReminders"
                        />
                        <input
                          type="checkbox"
                          className="cursor-pointer d-none"
                          onChange={e => {
                            setIConcentToReceiveTextNotifications(
                              e.target.checked
                            );
                            setConcentToReceiveTextNotificationsText(
                              e.target.checked ? "Yes" : "No"
                            );
                            setTextRemindersText(
                              e.target.checked ? "Yes" : "No"
                            );
                          }}
                          checked={iConcentToReceiveTextNotifications}
                        />
                        <span className={`${s.customCheckbox} ${iConcentToReceiveTextNotifications ? s.checked : ''}`}></span>
                        {/* Text me with updates about this meeting */}
                        Text me meeting reminders
                      </label>
                    </div>

                    <label>
                      <input
                        type="submit"
                        // value="Schedule A Free Demo"
                        value="Schedule A Demo"
                        className="wpcf7-form-control has-spinner wpcf7-submit"
                      />
                      <span className="wpcf7-spinner"></span>
                    </label>
                    <div
                      className="wpcf7-response-output"
                      aria-hidden="true"
                    ></div>
                  </form>
                )}
                {messageSent === true && (
                  <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    {!!thankYouImage?.data
                      ? <GatsbyImage
                        placeholder="none"
                        loading="eager"
                        image={thankYouImage.data}
                        alt={thankYouImage.alt}
                        className="mw-100" />
                      : <StaticImage
                        placeholder="none"
                        loading="eager"
                        alt="thank_you"
                        src="../../../images/thank_you.png"
                      />
                    }
                    <div className={`${s.thankYou} text-center`}>
                      {!!block?.thankYou?.text
                        ? <>{parse(block?.thankYou?.text)}</>
                        : <>Thank you! <br /> You are all set!</>
                      }
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </section>
  );
};

export default ContactForm;
